import React, { useState, useEffect } from "react";
import { Input, Button } from "@fragments";
import { LinkRounded, EditRounded, DeleteRounded, CheckRounded } from "@mui/icons-material";

export default function LinkInfo({ data, onUpdate, onDelete }) {
    const [open, setOpen] = useState(false);
    const [text, setText] = useState(data.text);
    const [url, setUrl] = useState(data.url);

    useEffect(() => {
        setText(data.text);
        setUrl(data.url);
    }, [data]);

    function handleDelete() {
        window.openConfirm({
            title: "Excluir link",
            headline: "Tem certeza que deseja excluir este link?",
            buttons: [
                {
                    text: "Excluir",
                    onClick: onDelete,
                    color: "error",
                    variant: "contained"
                },
                {
                    text: "Cancelar",
                    variant: "text"
                }
            ]
        });
    }

    if (!open) {
        return (
            <div className="description-link-row">
                <div className="description-link bsf-9">
                    <LinkRounded className="url-icon" />
                    <span className="title">{text || <i>(Não configurado)</i>}</span>
                    <span className="url">{url}</span>
                    <Button
                        color="overlay"
                        onClick={() => setOpen(true)}
                        size="small"
                        icon={<EditRounded />}
                    />
                    <Button
                        color="overlay"
                        onClick={handleDelete}
                        size="small"
                        icon={<DeleteRounded />}
                    />
                </div>
            </div>
        );
    }

    return (
        <div className="link-info-block mt-2 mb-3 px-2 py-2">
            <Input.Text
                autoFocus
                emoji
                variant="dark"
                size={25}
                value={text}
                onInput={(val) => {
                    setText(val);
                    onUpdate({ ...data, text: val });
                }}
                label="Título do link"
                placeholder="O título do link será o texto do botão no app"
            />
            <Input.Text
                start="https://"
                variant="dark"
                size={180}
                value={url}
                onInput={(val) => {
                    setUrl(val);
                    onUpdate({ ...data, url: val });
                }}
                label="Link"
                placeholder="https://seusite.com"
            />
            <div className="mt-1 link-buttons-footer">
                <Button
                    color="error"
                    onClick={handleDelete}
                    endIcon={<DeleteRounded />}
                    text={"Excluir"}
                />
                <Button
                    color="overlay"
                    onClick={() => {
                        if (!text || text.trim().length === 0) {
                            window.setSnackbar('Infome um título para o link', 'error');
                            return;
                        }
                        if (!url || url.trim().length === 0) {
                            window.setSnackbar('Infome a URL do link', 'error');
                            return;
                        }
                        const urlPattern = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;
                        if (!urlPattern.test(url)) {
                            window.setSnackbar('O link informado é inválido', 'error');
                            return;
                        }

                        setOpen(false);
                    }}
                    endIcon={<CheckRounded />}
                    text={"Concluir edição"}
                />
            </div>
        </div>
    );
}
